export enum PagePaths {
  partner = "/partner",
  userSettings = "/partner/user",
  platformSettings = "/partner/platform/settings",
  platformBranding = "/partner/platform/branding",
  platformSocial = "/partner/platform/social",
  platformCustomCovers = "/partner/platform/covers",
  platformPages = "/partner/platform/pages",
  platformMenu = "/partner/platform/menu",
  tags = "/partner/tags",
  countryAccesses = "/partner/country-accesses",
  posts = "/partner/posts",
  videos = "/partner/videos",
  storage = "/partner/storage",
  collections = "/partner/collections",
  products = "/partner/products",
  promocodes = "/partner/promocodes",
  streams = "/partner/streams",
  streamEntrypoints = "/partner/stream-entrypoints",
  chat = "/partner/chat",
  links = "/partner/links",
  widgets = "/partner/widgets",
  polls = "/partner/polls",
  broadcasts = "/partner/marketing/broadcasts",
  automations = "/partner/marketing/automations",
  emailTemplates = "/partner/marketing/emails",
  marketingContacts = "/partner/marketing/contacts",
  analytics = "/partner/analytics",
  users = "/partner/users",
  audienceConversations = "/partner/audience/conversations",
  audienceRequests = "/partner/audience/requests",
  purchases = "/partner/purchases",
  payments = "/partner/payments",
  billing = "/partner/billing",
  chargebacks = "/partner/chargebacks",
  subscriptions = "/partner/subscriptions",
  team = "/partner/team",
  reports = "/partner/reports",
}
